import * as React from "react";
import styled from "styled-components";
import { ValidationOption } from "../util/validate";

const CheckboxWrap = styled.label`
    display: inline-block;
    font-size: 1rem;
    font-weight: normal;
    position: relative;
    padding: 0.5rem 1rem 0.5rem 1.5rem;
    margin: 0;
    overflow: hidden;
    user-select: none;
    cursor: pointer;
    .cb__label {
        white-space: nowrap;
    }
    .cb__input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
        &:checked {
            ~ .cb__checkmark {
                background-color: var(--color-black, black);
                border-color: var(--color-black, black);
                &:after {
                    opacity: 1;
                    pointer-events: auto;
                }
            }
        }
    }
    .cb__checkmark {
        background-color: transparent;
        border: var(--form-input-border-width, 2px) solid var(--form-input-border-color, gray);
        display: inline-block;
        line-height: 1;
        pointer-events: none;
        position: absolute;
        top: .7rem;
        left: 0;
        height: 16px;
        width: 16px;
        transition: all .25s;
        &:after {
            content: "";
            position: absolute;
            left: 4px;
            top: 0.5px;
            width: 4.5px;
            height: 9px;
            border: solid var(--color-white, white);
            border-width: 0 1.5px 1.5px 0;
            transform: rotate(45deg);
            pointer-events: none;
            opacity: 0;
            transition: opacity .25s;
        }
    }
    &:hover {
        .cb__checkmark {
            background-color: var(--color-black, black);
            border-color: var(--color-black, black);
            &:after {
                opacity: 1;
                pointer-events: auto;
            }
        }
    }
`;

interface CheckboxFieldProps
{
    label: string;
    onChange: (checked: boolean) => void;
    inputProps: React.InputHTMLAttributes<HTMLInputElement>;
    validation?: ValidationOption;
}

const CheckboxField = (props: CheckboxFieldProps) =>
{
    const onChange = (e: React.FormEvent<HTMLInputElement>) =>
    {
        props.onChange(e.currentTarget.checked);
    };

    return (
        <CheckboxWrap>
            <input {...props.inputProps} className="cb__input" onChange={onChange} required={props.validation ? props.validation.required : false} />
            <span className="cb__label">{props.label}</span>
            <span className="cb__checkmark"></span>
        </CheckboxWrap>
    );
};

export default CheckboxField;